module.exports = __webpack_public_path__ + "static/toggle-multiple-b6d5449adfe5c0e8101dd2fcf01f1bf6.png";